<template>
  <div class="animated fadeIn">
    <b-row>
      <PageTitle></PageTitle>
      <filter-area
        @filterData="filterData()"
        @resetData="resetFilerAreaData()"
      >
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label for="activeRadio">{{$t('filterArea.label.state')}}</label>
              <b-form-radio-group id="activeRadio"
                                  :plain="true"
                                  :options="activeRadioOptions"
                                  v-model="filterArea.state">
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label for="code">{{$t('filterArea.label.code')}}</label>
              <b-form-input
                type="text"
                id="code"
                :placeholder="$t('filterArea.label.code')"
                v-model="filterArea.code">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label for="label">{{$t('filterArea.label.name')}}</label>
              <b-form-input
                type="text"
                id="label"
                :placeholder="$t('filterArea.label.name')"
                v-model="filterArea.label">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </filter-area>

      <b-col lg="12">
        <b-card>
          <b-table
            :stacked="stacked"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="items"
            :fields="captions"
            :current-page="1"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :per-page="perPage"
            @sort-changed="sortingChanged"
            :no-sort-reset="true"
            :no-local-sorting="true">
            <template slot="actions" slot-scope="data">
              <div class="btn-group" role="group">
                <router-link tag="button" class="btn btn-primary fa fa-search" v-b-tooltip.hover :title="$t('actions.show')"
                             :to="{name: 'sourceShowRoute', params:{id: data.item.id}}">
                </router-link>
                <router-link tag="button" class="btn btn-warning fa fa-edit" v-b-tooltip.hover :title="$t('actions.edit')"
                             :to="{name: 'sourceEditRoute', params:{id: data.item.id}}">
                </router-link>
                <button class="btn btn-danger" v-b-tooltip.hover :title="$t('actions.delete')" @click="handleDelete(data.item)">
                  <i class="far fa-trash" />
                </button>
              </div>
            </template>
            <template slot="enabled" slot-scope="data">
              <c-switch
                class="mx-1"
                @change="updateStatus(data.item.id, data.item.enabled)"
                v-model="data.item.enabled"
                color="success"
                variant="pill"
                label/>
            </template>
          </b-table>

          <div class="row">
            <div class="col-sm-4">
              <b-pagination :total-rows="rowCount" :per-page="perPage" v-model="currentPage"
                            :prev-text="$t('actions.previous')"
                            :next-text="$t('actions.next')"
                            hide-goto-end-buttons @input="fetchData(currentPage)"/>
            </div>
            <div class="col-sm-6"></div>
            <div class="col-sm-2">
              <router-link class="btn btn-primary btn-block float-right" role="button" :to="{path: `/sources/new`}" push>
                {{ $t('actions.create') }}
              </router-link>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="Eliminazione Sorgente" class="modal-danger" v-model="deleteModal" @ok="deleteSource"
             ok-variant="danger" v-if="selectedSource">
      {{ $t('page.generic.deleteMessage', {n: selectedSource.code}) }}
    </b-modal>
  </div>
</template>
<script>
import PageTitle from '@/components/PageTitle'
import i18n from '@/config/i18n'
import CustomSwitch from '../../components/CustomSwitch'
import FilterArea from '../../components/FilterArea'
import miniToastr from 'mini-toastr' //ES6
import SourceService from "@/services/SourceService";

const sourceService = SourceService.build()

export default {
  name: 'sourceList',
  inheritAttrs: false,
  components: {
    PageTitle,
    cSwitch: CustomSwitch,
    FilterArea,
  },
  props: {
    caption: {
      type: String,
      default: 'Sorgenti'
    },
    stacked: {
      type: String,
      default: 'sm'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 7
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'enabled',
          sortable: true,
          label: 'Stato',
        },
        {
          key: 'code',
          sortable: true,
          label: i18n.t('page.generic.code')
        },
        {
          key: 'label',
          sortable: true,
          label: i18n.t('page.generic.name'),
        },
        {
          key: 'description',
          sortable: false,
          label: i18n.tc('page.generic.description')
        },
        {
          key: 'timeToLive',
          sortable: true,
          label: i18n.tc('source.timeToLive'),
          formatter: 'timeToLiveFormatter'
        },
        {
          key: 'actions',
          sortable: false,
          label: 'Azioni'
        }
      ],
      currentPage: 1,
      tableData: [],
      tableTotalRows: 0,
      sortBy: 'code',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      activeRadioOptions: [
        {text: 'Attivo',value: true},
        {text: 'Disattivo',value: false},
      ],
      filterArea: {},
      deleteModal: false,
      selectedSource: null
    }
  },
  created() {
    miniToastr.init(); // config can be passed here miniToastr.init(config)
    miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
    this.fetchData(1);
  },
  computed: {
    items: function () {
      const items = this.tableData;
      return Array.isArray(items) ? items : []
    },
    captions: function () {
      return this.fields
    },
    rowCount: function () {
      return this.tableTotalRows
    },
  },
  methods: {
    async updateStatus(id, status) {
      try {
        await sourceService.update({id: id, enabled: status})
        miniToastr.info(`Sorgente ${status?'abilitata':'disabilitata'} con successo`);
      } catch (exception) {
        miniToastr.error(exception.message)
      }
    },
    timeToLiveFormatter(value) {
      return `${value} ore`
    },
    async fetchData(currentPage) {
      (
        {
          data: this.tableData = [],
          total: this.tableTotalRows = 0
        } = await sourceService.search(
          {
            max: this.perPage,
            offset: (currentPage - 1) * this.perPage,
            sort: this.sortBy,
            order: (this.sortDesc ? 'desc' : 'asc'),
            enabled: this.filterArea.state,
            code: this.filterArea.code,
            label: this.filterArea.label,
          }
        )
      )

    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.fetchData(this.currentPage)
    },
    filterData(){
      this.fetchData(1)
    },
    resetFilerAreaData(){
      this.filterArea = {
        state : null,
        code: null,
        label: null,
      };
      this.fetchData(1)
    },
    handleDelete(source) {
      this.deleteModal = true;
      this.selectedSource = source;
    },
    async deleteSource() {
      try {
        // TODO Verificare cancellazione solo se non associata ad altre prestazioni
        await sourceService.destroy(this.selectedSource.id);
        this.$router.replace({name: 'sourceRoute'});
        miniToastr.info("Sorgente cancellata con successo!")
      } catch (exception) {
        miniToastr.error(exception.message)
      } finally {
        this.selectedSource = null;
        this.fetchData(this.currentPage);
      }
    }
  }
}
</script>

